import PropTypes from 'prop-types';

export const Amenity = PropTypes.shape({
  amenityId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
});

export default Amenity;
